export { default } from './SpaDaysPage';
